import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import PartnersCompanyList from './PartnersCompanyList';
import PerformanceChart from './PerformanceChart';
import PerformanceMonitoringHeaders from './PerformanceMonitoringHeaders';

// import PerformanceMonitoringSearch from './PerformanceMonitoringSearch';

const PerformanceMonitoring = () => {
  return (
    <Page title='Logirate | Performance Monitoring'>
      <PageLayout>
        <Container>
          <PerformanceMonitoringHeaders />
          {/* <PerformanceMonitoringSearch /> */}
          <PerformanceChart />
          <PartnersCompanyList />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default PerformanceMonitoring;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
